const flights = {
  flight: "Πτήση", // translated
  flights: "Πτήσεις", // translated
  originDepartureDate: "Αναχώρηση", // translated
  destinationDepartureDate: "ΕΠΙΣΤΡΟΦΗ", // translated
  outbound: "Εξερχόμενος", // translated
  inbound: "Εισερχόμενος", // translated
  travelTime: "Χρόνος ταξιδιού", // translated
  selected: "επιλεγμένο", // translated
  select: "επιλέγω", // translated
  airline: "Αερογραμμή", // translated
  directFlight: "Απευθείας πτήση", // translated
  baggage: "Αποσκευές", // translated
  stops: "Σταματά", // translated
  nonStop: "Ακατάπαυστα", // translated
  oneStopMax: "Μία στάση μέγ", // translated
  twoStopsMax: "Δύο στάσεις μέγ", // translated
  anyStops: "Με οποιεσδήποτε στάσεις", // translated
  smallBaggage: "Μικρές αποσκευές", // translated
  bigBaggage: "Μεγάλες αποσκευές", // translated
  smallAndBigBaggage: "Μικρές και μεγάλες αποσκευές", // translated
  outboundStops: "Εξερχόμενες στάσεις", // translated
  inboundStops: "Εισερχόμενες στάσεις", // translated
  selectAirline: "Επιλέξτε αεροπορική εταιρεία", // translated
  baggageOption: "Επιλογή αποσκευών", // translated
  outboundDepartureAfter: "Αναχώρηση αναχώρησης μετά", // translated
  outboundArrivalAfter: "Άφιξη αναχώρησης μετά", // translated
  inboundDepartureAfter: "Αναχώρηση εισερχόμενης μετά", // translated
  inboundArrivalTimeAfter: "Εισερχόμενη άφιξη μετά", // translated
  flightClass: "Κατηγορία πτήσης", // translated
  outboundDepAfter: "Έξω αναχώρηση μετά", // translated
  outboundArrivalAfrer: "Έξω άφιξη μετά", // translated
  inboundDepAfter: "Στην αναχώρηση μετά", // translated
  inboundArrivalAfter: "Στην άφιξη μετά", // translated
  airlines: "Αεροπορική(ες)", // translated
  lessThan: "Λιγότερο από", // translated
  layover: "Στάση", // translated
  duration: "Διάρκεια", // translated
  economy: "Οικονομία", // translated
  business: "Επιχείρηση", // translated
  with: "Με", // translated
  without: "Χωρίς", // translated
  twoOrMore: "Δύο ή περισσότερα", // translated
  departure: "Αναχώρηση", // translated
  return: "ΕΠΙΣΤΡΟΦΗ", // translated
  submit: "υποβάλλουν", // translated
  priceLessThan: "Τιμή μικρότερη από", // translated
  durationLessThan: "Διάρκεια μικρότερη από", // translated
  layoverLessThan: "Παράταση μικρότερη από", // translated
  noLayover: "Χωρίς καθυστέρηση", // translated
  durationLowestFirst: "Διάρκεια (πρώτα η χαμηλότερη)", // translated
  durationHighestFirst: "Διάρκεια (πρώτα η υψηλότερη)", // translated
  idType: "Τύπος ID", // translated
  idPassportCode: "Κωδικός Ταυτότητας/Διαβατηρίου", // translated
  expirationDate: "Ημερομηνία λήξης", // translated
  frequentFlyerNumber: "Αριθμός συχνού ταξιδιώτη", // translated
  frequentFlyerAirline: "Αεροπορική εταιρεία συχνών επιβατών", // translated
  dateOfBirth: "Ημερομηνια γεννησης", // translated
  infant: "Βρέφος", // translated
  phone: "Τηλέφωνο", // translated
  title: "Τίτλος", // translated
  noLuggageIncluded: "Δεν περιλαμβάνονται αποσκευές", // translated
  includesLuggage: "Περιλαμβάνει αποσκευές", // translated
  outboundFlight: "Πτήση αναχώρησης", // translated
  inboundFlight: "Εισερχόμενη πτήση", // translated
  flightNumber: "Αριθμός πτήσης", // translated
  flightNumbers: "Αριθμοί πτήσης", // translated
  cabinClassType: "Τύπος κατηγορίας καμπίνας", // translated
  aircraftType: "Τύπος αεροσκάφους", // translated
  airlineName: "Όνομα αεροπορικής εταιρείας", // translated
  no: "Οχι", // translated
  yes: "Ναί", // translated
  anyFlights: "Οποιεσδήποτε πτήσεις", // translated
  oneStop: "Μια στάση", // translated
  direct: "Απευθείας", // translated
  directFlights: "Απευθείας πτήσεις", // translated
  all: "Ολα", // translated
  first: "Πρώτα", // translated
  premiumEconomy: "Prem. Οικονομία", // translated
  withBaggageOnly: "Μόνο με αποσκευές", // translated
  oneWay: "Μονόδρομος", // translated
  roundTrip: "Ταξίδι μετ επιστροφής", // translated
  withBaggage: "Με αποσκευές", // translated
  noBaggage: "Χωρίς αποσκευές", // translated
  requiredFields: "απαιτούμενα πεδία", // translated
  nonRequiredFields: "Μη υποχρεωτικά πεδία", // translated
  cabinClass: "Κατηγορία καμπίνας", // translated
  brandName: "Μάρκα", // translated
  performNewSearch: "Πραγματοποιήστε μια νέα αναζήτηση", // translated
  outboundDeparture: "Εξωτερική Αναχώρηση", // translated
  inboundDeparture: "Εισερχόμενη Αναχώρηση", // translated
  created: "Δημιουργήθηκε", // translated
  freeCancellationAvailable: "Δωρεάν ακύρωση διαθέσιμη", // translated
  freeCancellationDeadline: "Δωρεάν προθεσμία ακύρωσης", // translated
  externalReference: "Εξωτερική αναφορά", // translated
  outboundflightNumber: "Αριθμός εξερχόμενης πτήσης", // translated
  inboundflightNumber: "Αριθμός εισερχόμενης πτήσης", // translated
  arrival: "Αφιξη", // translated
};


export default flights;
